import type { FunnelStep } from '~/lib/types'

const FILLS = ['bg-stage-1', 'bg-stage-2', 'bg-stage-3', 'bg-stage-4', 'bg-good']

/*
  Horizontal funnel. Each bar is cumulative — students who reached that stage
  or better — so bars shorten monotonically and the drop between two bars is
  the loss at that step. Values are direct-labeled; no legend needed for a
  single measure.
*/
export default function FunnelChart({ steps }: { steps: FunnelStep[] }) {
  const top = steps[0]?.reached ?? 1

  return (
    <ol className="flex flex-col gap-3">
      {steps.map((step, index) => {
        const width = Math.max((step.reached / top) * 100, 1.5)
        const dropped = index > 0 ? steps[index - 1].reached - step.reached : null

        return (
          <li key={step.key}>
            <div className="flex items-baseline justify-between gap-4 text-sm">
              <span className="font-medium">{step.label}</span>
              <span className="text-ink-2 [font-variant-numeric:tabular-nums]">
                {step.reached.toLocaleString()}
                <span className="ml-2 text-xs text-faint">{step.share}%</span>
              </span>
            </div>

            <div className="mt-1.5 h-2.5 rounded-full bg-surface-2">
              <div
                className={`h-full rounded-full ${FILLS[index] ?? 'bg-stage-4'}`}
                style={{ width: `${width}%` }}
              />
            </div>

            {dropped !== null && dropped > 0 && (
              <p className="mt-1 text-xs text-faint">
                {dropped.toLocaleString()} dropped off here
              </p>
            )}
          </li>
        )
      })}
    </ol>
  )
}
